import { computed } from 'vue'
import type { SerializableError } from '@/infrastructure/errors'
import { useErrorStore } from '@/stores/error'

export function useErrors(source: string) {
  const errorStore = useErrorStore()

  const sourceErrors = computed(() => errorStore.getErrorsBySource(source))
  const error = computed<SerializableError | null>(() => {
    const lastApiError = [...sourceErrors.value].reverse().find(item => item.type === 'api')
    if (!lastApiError) return null
    return {
      message: lastApiError.message,
      statusCode: lastApiError.statusCode,
    }
  })
  const hasError = computed(() => error.value !== null)

  function setApiError(apiError: SerializableError | Error | unknown) {
    errorStore.setApiError(apiError, source)
  }

  function setUIError(message: string) {
    errorStore.setUIError(message, source)
  }

  function clearErrors() {
    errorStore.clearErrorsBySource(source)
  }

  return {
    sourceErrors,
    error,
    hasError,
    setApiError,
    setUIError,
    clearErrors,
  }
}
